import { logWBLaunchV2Info } from '@/features/logging/action-logger';
import {
  CLIENT_TO_WRAPPER_EVENT_TYPES,
  FetchGameFailure,
  FetchGameSuccess,
  GameClientInitialized,
  GameSwitch,
  ProxyMessage,
  ResumeIncompleteGame,
  SetAudioEnabled,
  SetGameLoaded,
  SetGameProgress,
  SetProviderError,
  SetSpinInProgress,
} from '@/features/wrapper-proxy/proxy-message';

export const iosBridgeMapper = (event: ProxyMessage) => {
  logWBLaunchV2Info(`Map IOS event --------- `);

  const IOS_ACTION_MAPPER = {
    [CLIENT_TO_WRAPPER_EVENT_TYPES.SET_GAME_LOAD_PROGRESS]: (
      e: SetGameProgress,
    ) =>
      window?.webkit?.messageHandlers?.loadingProgressHandler?.postMessage(
        e.payload.toString(),
      ),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.SET_GAME_LOADED]: (e: SetGameLoaded) =>
      window?.webkit?.messageHandlers?.gameReadyHandler?.postMessage(e),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.SET_AUDIO_ENABLED]: (e: SetAudioEnabled) => {
      const handler = e.payload
        ? window?.webkit?.messageHandlers?.audioEnabledHandler
        : window?.webkit?.messageHandlers?.audioDisabledHandler;
      handler?.postMessage?.(e);
    },

    [CLIENT_TO_WRAPPER_EVENT_TYPES.SET_SPIN_IN_PROGRESS]: (
      e: SetSpinInProgress,
    ) => {
      const handler = e.payload
        ? window?.webkit?.messageHandlers?.wagerStartedHandler
        : window?.webkit?.messageHandlers?.wagerCompleteHandler;
      handler?.postMessage?.(e);
    },
    [CLIENT_TO_WRAPPER_EVENT_TYPES.SET_PROVIDER_ERROR]: (e: SetProviderError) =>
      window?.webkit?.messageHandlers?.displayErrorMessageHandler?.postMessage(
        e.payload,
      ),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.FETCH_GAME_FAILURE]: (e: FetchGameFailure) =>
      window?.webkit?.messageHandlers?.displayErrorMessageHandler?.postMessage({
        errorCode: e.payload?.errorCode
          ? e.payload.errorCode
          : 'GC/FETCH_GAME_FAILURE',
      }),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.FETCH_GAME_SUCCESS]: (e: FetchGameSuccess) =>
      window?.webkit?.messageHandlers?.fetchGameSuccess?.postMessage(e),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.CONTEXT_PARAM_MISSING]: () =>
      window?.webkit?.messageHandlers?.displayErrorMessageHandler?.postMessage({
        errorCode: 'GC/CONTEXT_PARAM_MISSING',
      }),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.RESET_GAME]: () =>
      window?.webkit?.messageHandlers?.reloadGameReceived?.postMessage(
        'reloadGame',
      ),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.INITIALIZE_HANDSHAKE]: (
      e: GameClientInitialized,
    ) => window?.webkit?.messageHandlers?.handshakeHandler?.postMessage(e),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.CLOSE_GAME_LAUNCHER]: () =>
      window?.webkit?.messageHandlers?.closeGameReceived?.postMessage(
        'closeGame',
      ),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.REQUEST_GAME_WINDOW_UI_STATE]: () =>
      window?.webkit?.messageHandlers?.requestGameWindowUiState?.postMessage(
        'gameWindowUiState',
      ),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.SHOW_FUNDS]: () =>
      window?.webkit?.messageHandlers?.showFundsHandler?.postMessage(
        'showFunds',
      ),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.RESUME_INCOMPLETE_GAME]: (
      e: ResumeIncompleteGame,
    ) =>
      window?.webkit?.messageHandlers?.resumeIncompleteGame?.postMessage?.(e),
    [CLIENT_TO_WRAPPER_EVENT_TYPES.GAME_SWITCH]: (e: GameSwitch) =>
      window?.webkit?.messageHandlers?.gameSwitchHandler?.postMessage?.(e),
  } as const;

  return IOS_ACTION_MAPPER[event.type];
};
